import React from 'react'
import { Link } from 'react-router-dom'
import image1 from '../images/hero.png'
import logo from '../images/logo.png'

const Hero = () => {
  return (
    
    <div
      style={{
        backgroundImage: 'url(' + image1 + ')',
        backgroundRepeat: 'no-repeat'
      }}
      className='bg-cover'
    >
      <div className='text-blue-500 text-3xl font-medium flex justify-center items-center flex-col h-screen w-screen2222 text-center'>
        <a href='https://www.mxwireless.com/shop'
          className='font-normal cursor-pointer text-xl py-3 px-4 mb-15 hover:bg-blue-700 hover:scale-105 transition-all duration-300 bg-blue-500 text-gray-100 rounded-full'
        >
          SHOP NOW
        </a>
        <img src={logo} width='480px' alt='logo' />
        <h3 className='p-3 text-blue-500 text-xl md:text-2xl'>
          Your one-stop shop for everything Wireless
        </h3>
      </div>
    </div>
  )
}

export default Hero
